import { render, staticRenderFns } from "./sendSmsForm.vue?vue&type=template&id=489606a4&scoped=true&"
import script from "./sendSmsForm.vue?vue&type=script&lang=js&"
export * from "./sendSmsForm.vue?vue&type=script&lang=js&"
import style0 from "./sendSmsForm.vue?vue&type=style&index=0&id=489606a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "489606a4",
  null
  
)

export default component.exports